import { useTranslation } from "react-i18next";

const STATUS_STYLES = {
  pending: "bg-amber-100 text-amber-800 border border-amber-200",
  confirmed: "bg-emerald-100 text-emerald-800 border border-emerald-200",
  change_proposed: "bg-sky-100 text-sky-800 border border-sky-200",
  rejected: "bg-rose-100 text-rose-800 border border-rose-200",
  canceled_by_user: "bg-slate-100 text-slate-700 border border-slate-200",
  cancelled_by_customer: "bg-slate-100 text-slate-700 border border-slate-200",
  cancelled_by_venue: "bg-red-100 text-red-800 border border-red-200",
  completed: "bg-violet-100 text-violet-800 border border-violet-200",
  no_show: "bg-red-100 text-red-800 border border-red-200",
};

export default function BookingStatusBadge({ status, size = "sm" }) {
  const { t } = useTranslation();
  const style = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border border-slate-200";
  const label = t(`booking_status:${status}`, { defaultValue: status.replace(/_/g, " ") });
  const padding = size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${padding} ${style}`}
      data-testid={`booking-status-${status}`}
    >
      {label}
    </span>
  );
}
